export const iterate = (data, arr) => {
  for (let i = 0; i < Object.keys(data).length; i++) {
    arr.push(data[Object.keys(data)[i]]);
  }
};

export const getDeviceScreen = (width) => {
  switch (true) {
    case width < 576:
      return "small";
    case width >= 576 && width < 768:
      return "mobile";
    case width >= 768 && width < 1224:
      return "tablet";
    case width >= 1024:
      return "desktop";
    default:
      return "desktop";
  }
};
